import {
  renderRequiredRule,
  renderValidator,
  renderLengthFieldRule,
  checkValidityInn,
} from "@/utils/renderRulesForm";

export default (sender) => ({
  cityFrom: [renderRequiredRule("Пожалуйста выберите город", 'change')],
  senderType: [],
  innSender: [
    renderRequiredRule("Пожалуйста введите ИНН"),
    renderValidator({
      validatorFunc: checkValidityInn,
      message: "Некорректно введён ИНН",
    }),
    renderLengthFieldRule({
      min: 10,
      max: 12,
      message: "ИНН должен состоять от 10 до 12 символов",
    }),
  ],
  name: [renderRequiredRule("Пожалуйста введите название организации")],
  surnameSender: [
    renderRequiredRule("Введите фамилию"),
    renderValidator({
      validatorFunc: (value) => value.length > 0,
      message: "Введите фамилию",
    }),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 2),
        message: "Слишком коротко",
    }),
  ],
  firstNameSender: [
    renderRequiredRule("Введите имя"),
    renderValidator({
      validatorFunc: (value) => value.length > 0,
      message: "Введите имя",
    }),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 2),
        message: "Слишком коротко",
    }),
  ],
  secondNameSender: [
    renderRequiredRule("Введите отчество"),
    renderValidator({
      validatorFunc: (value) => value.length > 0,
      message: "Введите отчество",
    }),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 2),
        message: "Слишком коротко",
    }),
  ],
  phoneSender: [
    renderRequiredRule("Введите телефон"),
    renderValidator({
      validatorFunc: (value) =>
        !!value.match(/^\+{0,1}\d \([3,4,6-9]\d{2}\) \d{3}-\d{2}-\d{2}$/),
      message: "Некорректно введён номер",
    }),
  ],
  emailSender: [
    {
      validator: (rule, value, callback) => {
        if (
          (sender.senderType && (value === "")) ||
          (!(value === "") && !value.match(/^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/))
        ) {
          callback(new Error("Пожалуйста введите почту"));
        }
        // else if (!value.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
        //   callback(new Error("Почта введена неверно"));
        // }
        callback();
      },
      trigger: "blur",
    },
    // renderValidator({
    //   validatorFunc: (value) =>
    //     !!value.match(
    //       /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    //     ) ,
    //   message: "Пожалуйста введите почту",
    // }),
    ],
});
